import { render, staticRenderFns } from "./PartRoleFeatures.vue?vue&type=template&id=63b16629&scoped=true"
import script from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PartRoleFeatures.vue?vue&type=style&index=0&id=63b16629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b16629",
  null
  
)

export default component.exports